import key from 'weak-key';

// components
import { BreadcrumbItem } from './breadcrum-item';

// styles
import styles from './breadcrumb.module.scss';

// utils
import { isEmpty } from 'utils/is-empty';
import { useBreadcrumbs } from './use-breadcrumbs';

export function Breadcrumbs({
  items,
  size,
}: Readonly<{
  items: Partial<Breadcrumb>[];
  size?: 'tiny' | 'small' | 'big' | 'huge';
}>) {
  let { hiddenNavProps, hiddenOlProps, truncatedBreadcrumbs, olProps, navProps } =
    useBreadcrumbs(items);

  return (
    <>
      {/* Hidden breadcrumbs for offscreen measurement to avoid flickering */}
      <NavigationBreadcrumbs
        size={size}
        items={items}
        navProps={hiddenNavProps}
        olProps={hiddenOlProps}
      />
      <NavigationBreadcrumbs
        size={size}
        items={truncatedBreadcrumbs}
        navProps={navProps}
        olProps={olProps}
      />
    </>
  );
}

function NavigationBreadcrumbs({
  items,
  navProps,
  olProps = {},
  size,
}: Readonly<{
  items: Partial<Breadcrumb>[];
  navProps: Record<string, unknown>;
  olProps?: Record<string, unknown>;
  size?: 'tiny' | 'small' | 'big' | 'huge';
}>) {
  return (
    <nav data-size={size} {...navProps} className={styles.breadcrumbs}>
      <ol {...olProps} className={styles.scrollable}>
        {items.map((breadcrumb, index) => {
          if (isEmpty(breadcrumb)) return null;

          return (
            <BreadcrumbItem
              {...breadcrumb}
              key={key(breadcrumb)}
              isHome={index === 0}
              isLast={index === items.length - 1}
            />
          );
        })}
      </ol>
    </nav>
  );
}
